module.exports = __webpack_public_path__ + "static/media/loop-icon.e69e788f.svg";